import type { FunctionComponent } from "react";
import DashboardBrandAdminPartial from "../../../partials/admin/home/dashboard-brand.admin.partials";

export const BrandAdminScreen: FunctionComponent = () => {
	return <DashboardBrandAdminPartial />;
};
